export enum SlideTheme {
    LIGHT = "LIGHT",
	DARK = "DARK"
}